import type ExcelJS from 'exceljs';

const EXCEL_NEIS_LEGEND_UNREGISTERED = 'FFD32F2F';

/** NEIS export(PDF·Excel) 페이지 상단 범례 — Excel 한 행(병합) */
export function appendWeeklyGuideNeisLegendToSheet(
  sheet: ExcelJS.Worksheet,
  startRowIndex: number,
  columnCount: number
): number {
  const row = sheet.getRow(startRowIndex);
  row.getCell(1).value = {
    richText: [
      { text: ': 기초 시간표에서 변경된 영역', font: { size: 9, color: { argb: 'FF666666' } } },
      { text: '    ', font: { size: 9 } },
      { text: ': 기초 시간표와 같은 편제이나 색상(전담 과목 등)이 다른 영역', font: { size: 9, color: { argb: 'FF666666' } } },
      { text: '    ', font: { size: 9 } },
      { text: '텍스트', font: { size: 9, bold: true, color: { argb: EXCEL_NEIS_LEGEND_UNREGISTERED } } },
      { text: ' : 편제에 등록되지 않은 시간표', font: { size: 9, color: { argb: 'FF666666' } } },
      { text: '    ', font: { size: 9 } },
      { text: ': 요일별 기준 수업시수에서 삭제 또는 추가된 영역', font: { size: 9, color: { argb: 'FF666666' } } },
    ],
  };
  sheet.mergeCells(startRowIndex, 1, startRowIndex, columnCount);
  row.getCell(1).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
  row.height = 18;
  return startRowIndex + 1;
}
